import { defineVizView } from "@/lib/ai/visualization/views/shared/view-definition";
import {
  buildTableElement,
  compileTableSpec,
  validateTableSpec,
} from "@/lib/ai/visualization/views/table/logic";
import { tableAuthoringSchema } from "@/lib/ai/visualization/views/table/schema";

/**
 * `table` definition の SSOT エントリ。
 */
export const tableDefinition = defineVizView({
  type: "table",
  componentType: "VizTable",
  authoringSchema: tableAuthoringSchema,
  authoringPrompt: {
    summary:
      "Detail-preserving table for audit, exact row inspection, and multi-metric leaderboards.",
    requiredKeys: ["columns", "sort", "limit"],
    optionalKeys: [],
    selectionRules: [
      "Set columns to [] when the compiler should choose dataset-default visible columns.",
      "Use sort.key plus sort.direction when the table must behave like a ranking or leaderboard.",
      "Choose table when exact row inspection or several visible metrics matter more than a compact visual summary.",
      "A visualization table still requires view.type=table; do not substitute markdown or prose.",
    ],
    avoidWhen: [
      "Trend, ranking, or relationship requests that a chart can express more directly.",
      "Prompts that clearly ask for one compact visual summary instead of row-level detail.",
      "Requests where the main goal is shape, momentum, or category ordering rather than exact values.",
    ],
    minimalExamples: [
      {
        label: "detail-table",
        view: {
          type: "table",
          columns: [],
          sort: null,
          limit: 10,
        },
      },
    ],
  },
  datasetRequirements: {
    requiresTimeDimension: false,
    requiresCategoryDimension: false,
    minMetricCount: 0,
    requiresCompareMode: false,
  },
  validateSpec: validateTableSpec,
  buildElement: buildTableElement,
  compileSpec: compileTableSpec,
});
